export const PageDataState = {
    Searchs: {
        training_details_enterprise_eb_03_id: {
            type: 'text',
            id: 'training_details_enterprise_eb_03_id',
            label: '',
            value: '',
            placeholder: '',
        },
        /** 
        enterprise_name: {
            type: 'text',
            id: 'enterprise_name',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        }, 
        */
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        training_details_enterprise_eb_03_id: {
            type: 'select',
            id: 'training_details_enterprise_eb_03_id',
            label: 'รุ่น/ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        evaluator: {
            type: 'text',
            id: 'evaluator',
            label: 'ตำแหน่งของผู้ประเมิน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                min: 5,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        employer_investment: {
            type: 'text',
            id: 'employer_investment',
            label: 'จำนวน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 100,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },         
        question_1: {
            type: 'radio',
            id: 'question_1',
            label: '1. หลักสูตรได้ชี้แจงรายละเอียดและรูปแบบเกี่ยวกับการอบรมตามแนวทางของ EEC Model Type B แก่สถานประกอบการ',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        question_2: {
            type: 'radio',
            id: 'question_2',
            label: '2. สถานประกอบการได้ร่วมออกแบบหลักสูตร หรือเสนอแนะรายละเอียด เนื้อหา และทักษะที่ต้องการให้บุคลากรได้รับจากการอบรมแก่หลักสูตร',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        question_3: {
            type: 'radio',
            id: 'question_3',
            label: '3. หลักสูตรได้มีการคัดกรองบุคลากรที่มีคุณสมบัติเหมาะสมให้แก่สถานประกอบการ เพื่อคัดเลือกให้เข้าอบรมในหลักสูตร',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        question_4: {
            type: 'radio',
            id: 'question_4',
            label: '4. หลักสูตรได้แจ้งรายละเอียดและวัตถุประสงค์เกี่ยวกับการอบรมทีมวิทยากร และทักษะที่บุคลากรจะได้รับภายหลังเสร็จสิ้นการอบรมแก่สถานประกอบการ',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        question_5: {
            type: 'radio',
            id: 'question_5',
            label: '5. แนวทางการฝึกอบรมของหลักสูตรมีความน่าเชื่อถือ และสามารถเพิ่มทักษะให้กับบุคลากรของสถานประกอบการได้จริง',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        question_6: {
            type: 'radio',
            id: 'question_6',
            label: '6. บุคลากรที่เข้าร่วมอบรมในหลักสูตรมีทักษะในการปฏิบัติงานเพิ่มขึ้น',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        question_7: {
            type: 'radio',
            id: 'question_7',
            label: '7. บุคลากรสามารถนำองค์ความรู้ที่ได้จากการอบรมในหลักสูตรมาประยุกต์ใช้ในการทำงานได้จริง',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },   
        question_8: {
            type: 'radio',
            id: 'question_8',
            label: '8. บุคลากรที่เข้าร่วมอบรมในหลักสูตรสามารถถ่ายทอดองค์ความรู้หรือทักษะที่ได้เรียนรู้จากการอบรมแก่เพื่อนร่วมงาน อันเป็นการยกระดับคุณภาพการทำงานของสถานประกอบการ',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        question_9: {
            type: 'radio',
            id: 'question_9',
            label: '9. หลักสูตรมีการติดตามผลสัมฤทธิ์ของบุคลากรที่ผ่านการอบรม โดยมีการติดต่อประสานงานกับสถานประกอบการอย่างน้อย ๑ ครั้ง ภายหลังเสร็จสิ้นการฝึกอบรม',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        question_10: {
            type: 'radio',
            id: 'question_10',
            label: '10. ผลลัพธ์โดยรวมของบุคลากรที่ได้รับการอบรมจากหลักสูตรตามแนวทางของ EEC Model Type B',
            value: '',
            validator:{
                type: 'radio',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        suggestions: {
            type: 'textarea',
            rows: 5,
            id: 'suggestions',
            label: 'ข้อเสนอแนะ / ข้อควรปรับปรุง',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },                                              
    },         
    InputGroup: {
        Radio: {
            question: {
                display: 'inline',
                inputs: [
                    {id: '5', value: '5', label: '5'},
                    {id: '4', value: '4', label: '4'},
                    {id: '3', value: '3', label: '3'},
                    {id: '2', value: '2', label: '2'},
                    {id: '1', value: '1', label: '1'}
                ],
            }
        },        
    },
}  
        /** 
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        start_date: {
            type: 'text',
            id: 'start_date',
            label: 'วันที่เริ่มต้น',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        end_date: {
            type: 'text',
            id: 'end_date',
            label: 'วันที่สิ้นสุด',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        },         
        trainee_count: {
            type: 'text',
            id: 'trainee_count',
            label: 'จำนวนบุคลากรที่เข้าร่วมอบรม (คน)',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 10000
            },
            error: { status: null, msg: '' }
        },         
        */                    